import React from "react";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import Members from "components/AboutUs/Members";
import { useSelector } from 'react-redux';
import MobileNavbar from "components/MobileNavbar";
import MobileFooter from "components/MobileFooter";

function AboutUs () {
    const isMobile = useSelector(state=> state.windowSize.isMobile);
    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbar />
            <Members />
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <Members />
            <Footer />
            </>
        )}
        </>
    )
};

export default AboutUs